import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import messages from 'routes/App/Apps/DataBrowser/translate'
import SelectList from 'components/common/SelectList'
import {
  fetchLocusGroupList,
  setActiveLocusGroup,
} from 'reducers/dataBrowser/reducer'
import Psfs from 'lib/psfs/Psfs'

class LocusGroupFilter extends Component {
  onLocusGroupChange = value => {
    const { activeLocusGroup, setActiveLocusGroup } = this.props
    const { index } = value

    if (value && activeLocusGroup !== index) {
      setActiveLocusGroup(index)
    }
  }

  fetchLocusGroupList = activeSite => {
    const psfs = new Psfs()
    psfs
      .addSort('name', 'desc')
      .addFilter('site', activeSite)
      .addFilter('visibleInUi', true)
      .addFields(['id', 'name'])

    this.props.fetchLocusGroupList({ psfs })
    this.props.setActiveLocusGroup(0)
  }

  componentDidMount() {
    this.fetchLocusGroupList(this.props.activeSite)
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite } = nextProps

    if (this.props.activeSite !== activeSite) {
      this.fetchLocusGroupList(activeSite)

      return false
    }

    return true
  }

  render() {
    const {
      locusGroupList,
      activeLocusGroup,
      intl: { formatMessage },
    } = this.props
    const locusGroup = List([
      { id: 0, name: formatMessage(messages.allGroups) },
      ...locusGroupList.toArray(),
    ])

    return (
      <SelectList
        variant="outlined"
        name="locus_group"
        label={formatMessage(messages.unitGroupList)}
        onChange={this.onLocusGroupChange}
        list={locusGroup}
        value={activeLocusGroup}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    locusGroupList: state.getIn(['dataBrowser', 'locusGroupList']),
    activeLocusGroup: state.getIn(['dataBrowser', 'activeLocusGroup']),
  }),
  {
    fetchLocusGroupList,
    setActiveLocusGroup,
  },
)(injectIntl(LocusGroupFilter))
